import {Grid, Box, styled, CardMedia} from '@mui/material';
import {Color} from '../../../common/theme';

const BackgroundBox = styled(Box)({
    paddingTop: 54,
    paddingBottom: 54,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
    backgroundColor: Color.SEA_GREEN,
});

export const DemoVideoSection = () => {
    return (
        <BackgroundBox>
            <Grid container>
                <Grid item md={3} />
                <Grid item md={6}>
                    <span
                        style={{
                            fontSize: 32,
                            color: Color.WHITE,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        <center>See it in action</center>
                    </span>
                </Grid>
            </Grid>
            <Grid style={{marginTop: 12}} container>
                <Grid item md={2} />

                <Grid item md={8}>
                    <CardMedia component={'video'} src={'/demo.mp4'} controls />
                </Grid>
            </Grid>
        </BackgroundBox>
    );
};
